import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const OTPVerification = ({ mobileNumber, onVerificationComplete }) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const { verifyOTP, generateOTP, error } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!otp) return;

    try {
      setLoading(true);
      await verifyOTP(mobileNumber, otp);
      onVerificationComplete();
    } catch (err) {
      console.error('Error verifying OTP:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      setResending(true);
      await generateOTP(mobileNumber);
    } catch (err) {
      console.error('Error resending OTP:', err);
    } finally {
      setResending(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 400 }}>
      <Typography variant="h5" gutterBottom>
        Verify OTP
      </Typography>
      
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Enter the 4-digit OTP sent to {mobileNumber}
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        fullWidth
        label="OTP"
        variant="outlined"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Enter 4-digit OTP"
        required
        inputProps={{
          maxLength: 4,
          pattern: '[0-9]*',
        }}
        sx={{ mb: 2 }}
      />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={loading || !otp}
        sx={{ mt: 2 }}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
      </Button>

      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Button
          variant="text"
          size="small"
          onClick={handleResend}
          disabled={resending || loading}
        >
          {resending ? 'Resending...' : "Didn't receive code? Resend OTP"}
        </Button>
      </Box>
    </Box>
  );
};

export default OTPVerification; 